<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-27 15:52:16
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-08-05 15:18:18
 -->
<template>
  <div class="pi-tag"
       :class="type">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "pi-tag",
  data() {
    return {
      className: "",
    };
  },
  methods: {},
  mounted() {},
  props: {
    type: {
      default: "",
      type: String,
    },
    index: {
      default: 0,
      type: Number,
    },
  },
};
</script>

<style lang="less">
.pi-tag {
  padding: 0.03rem 0.1rem;
  color: #999999;
  display: inline-block;
  border: 0.01rem solid #999;
  font-size: 0.24rem;
  line-height: 0.33rem;
  border-radius: 0.2rem;
  margin-left: 0.1rem;
}
.pi-tag.primary {
  border-color: #14cc80;
  color: #14cc80;
}
.pi-tag:first-child {
  margin-left: 0;
}
</style>
